export default __webpack_public_path__ + "static/media/p1.022138d1.png";